import { authAction } from "../store/actions";

export const mapStateToProps = (state) => {
  const {
    authReducer: {
      isLoggedIn,
      getCarerVisitSuccess,
      getCarerVisitError,
      getCarerVisitLoader,
      updateVisitSuccess,
      updateVisitError,
      updateVisitLoader,
      getCarerSummarySuccess,
      getCarerSummaryError,
      getCarerSummaryLoader
    },
  } = state;

  return {
    isLoggedIn,
    getCarerVisitSuccess,
    getCarerVisitError,
    getCarerVisitLoader,
    updateVisitSuccess,
    updateVisitError,
    updateVisitLoader,
    getCarerSummarySuccess,
    getCarerSummaryError,
    getCarerSummaryLoader
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getCarerVisits: (payload) =>
      dispatch(authAction.getCarerVisits(payload)),
    getCarerSummary: (payload) =>
      dispatch(authAction.getCarerSummary(payload)),
    updateVisit: (payload) =>
      dispatch(authAction.updateVisit(payload)),
  };
};
